var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inline-svg',{staticClass:"size-20",attrs:{"src":require(("../../../assets/img/brand-values/" + (_vm.name.toLowerCase()) + ".svg"))}})}
var staticRenderFns = []

export { render, staticRenderFns }